import { useApiClient } from '../../api/useApiClient';

/**
 * Servicio para el árbol documental
 * Encapsula todas las operaciones relacionadas con la estructura del árbol documental
 */
class DocTreeService {
    constructor(apiClient) {
        this.apiClient = apiClient;
    }

    /**
     * Obtener estructura completa del árbol documental
     * @returns {Promise} Response con estructura del árbol documental
     */
    async getArbolDocumental() {
        return this.apiClient.get('/api/v1/doc-tree');
    }

    /**
     * Obtener tipos de documentos disponibles
     * @returns {Promise} Response con lista de tipos de documentos
     */
    async getTiposDocumentos() {
        return this.apiClient.get('/api/v1/series');
    }

    /**
     * Obtener conteos de documentos para una serie específica
     * @param {string} idTipoDoc - ID de la serie
     * @returns {Promise} Response con conteos total y accesible
     */
    async getSerieCounts(idTipoDoc) {
        return this.apiClient.get(`/api/v1/series/${idTipoDoc}/counts`);
    }
}

/**
 * Hook personalizado para usar el servicio de árbol documental
 * @returns {DocTreeService} Instancia del servicio de árbol documental
 */
export const useDocTreeService = () => {
    const apiClient = useApiClient();
    return new DocTreeService(apiClient);
};

// Backward compatibility alias
export const useArbolDocumentalService = useDocTreeService;

export default DocTreeService;
